"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_components_1 = require("@apollo/react-components");
const reactstrap_1 = require("reactstrap");
const context_1 = require("../../../context");
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const inputs_1 = require("../../../inputs");
const MINUTES_BEFORE_RUN_TO_SEND_PROOF = [
    {
        label: '15 minutes before',
        value: 15,
    },
    {
        label: '30 minutes before',
        value: 30,
    },
    {
        label: '45 minutes before',
        value: 45,
    },
    {
        label: '1 hour before',
        value: 60,
    },
    {
        label: '1.5 hours before',
        value: 60 * 1.5,
    },
    {
        label: '2 hours before',
        value: 60 * 2,
    },
    {
        label: '3 hours before',
        value: 60 * 3,
    },
    {
        label: '4 hours before',
        value: 60 * 4,
    },
    {
        label: '5 hours before',
        value: 60 * 5,
    },
    {
        label: '6 hours before',
        value: 60 * 6,
    },
    {
        label: '7 hours before',
        value: 60 * 7,
    },
    {
        label: '8 hours before',
        value: 60 * 8,
    },
    {
        label: '9 hours before',
        value: 60 * 9,
    },
    {
        label: '10 hours before',
        value: 60 * 10,
    },
    {
        label: '11 hours before',
        value: 60 * 11,
    },
    {
        label: '12 hours before',
        value: 60 * 12,
    },
    {
        label: '14 hours before',
        value: 60 * 14,
    },
    {
        label: '16 hours before',
        value: 60 * 16,
    },
    {
        label: '18 hours before',
        value: 60 * 18,
    },
    {
        label: '20 hours before',
        value: 60 * 20,
    },
    {
        label: '22 hours before',
        value: 60 * 22,
    },
    {
        label: '24 hours before',
        value: 60 * 24,
    },
    {
        label: '36 hours before',
        value: 60 * (24 * 1.5),
    },
    {
        label: '48 hours before',
        value: 60 * (24 * 2),
    },
];
const SUBJECT_LINE_SOURCE = [
    {
        label: 'Set a default subject line',
        value: 'defaultText',
    },
    {
        label: 'Pull subject line from content feed',
        value: 'contentSystem',
    },
    {
        label: 'Require manual subject line be written before send (you can write a subject line when the proof is sent)',
        value: 'manualSubjectLine',
    },
];
const DAYS = [
    {
        label: 'Sunday',
        value: 'sunday',
    },
    {
        label: 'Monday',
        value: 'monday',
    },
    {
        label: 'Tuesday',
        value: 'tuesday',
    },
    {
        label: 'Wednesday',
        value: 'wednesday',
    },
    {
        label: 'Thursday',
        value: 'thursday',
    },
    {
        label: 'Friday',
        value: 'friday',
    },
    {
        label: 'Saturday',
        value: 'saturday',
    },
];
class WorkflowSettings extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            infoBoxIsOpen: true,
            showReplyToAddressUI: !!(this.props.workflow && this.props.workflow.campaignReplyToEmailAddress),
        };
    }
    render() {
        const hideCookieExists = !!js_cookie_1.default.get('osmosys.hideWorkflowsInfoAlert');
        return (react_1.default.createElement(context_1.OsmosysAppContext.Consumer, null, ({ currentUser }) => {
            if (!currentUser) {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            const { workflow } = this.props;
            // const tz = workflow.timezone || moment.tz.guess(false);
            const initialValues = Object.assign(Object.assign({
                campaignFromEmailAddress: null,
                campaignFromName: null,
                campaignListID: null,
                campaignReplyToEmailAddress: null,
                campaignSubjectLineSource: null,
                days: null,
                email: null,
                emailServiceProvider: null,
                everyday: false,
                minutesBeforeRunToSendProof: null,
                name: '',
                requireApproval: false,
                sendProof: false,
                time: null,
                usersThatCanApproveIds: null,
                usersToSendProofsTo: null,
            }, workflow), { campaignDefaultSubjectLine: workflow.campaignDefaultSubjectLine, campaignSubjectLineSource: workflow.campaignSubjectLineSource
                    ? SUBJECT_LINE_SOURCE.find(d => {
                        return workflow.campaignSubjectLineSource === d.value;
                    })
                    : null, days: workflow.days
                    ? DAYS.filter(d => {
                        return workflow && workflow.days
                            ? workflow.days.includes(d.value)
                            : [];
                    })
                    : null, minutesBeforeRunToSendProof: workflow.minutesBeforeRunToSendProof
                    ? MINUTES_BEFORE_RUN_TO_SEND_PROOF.find(d => {
                        return workflow.minutesBeforeRunToSendProof === d.value;
                    })
                    : null, time: workflow.time
                    ? moment_1.default(moment_1.default(workflow.time).format('HH:mm'), 'HH:mm').local()
                    : null });
            return (react_1.default.createElement(react_1.default.Fragment, null,
                !hideCookieExists && (react_1.default.createElement(reactstrap_1.Alert, { color: "info", className: "my-4 py-3", isOpen: this.state.infoBoxIsOpen, toggle: () => {
                        js_cookie_1.default.set('osmosys.hideWorkflowsInfoAlert', 'true');
                        this.setState({
                            infoBoxIsOpen: false,
                        });
                    }, id: "workflow-explainer-alert" },
                    react_1.default.createElement("p", { className: "lead" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faInfoCircle, className: "mr-2" }),
                        "How workflows work"),
                    react_1.default.createElement("ol", null,
                        react_1.default.createElement("li", null,
                            react_1.default.createElement("p", null, "Before a workflow runs, you can make edits to the campaign in advance.")),
                        react_1.default.createElement("li", null,
                            react_1.default.createElement("p", null, "When the workflow runs, a proof email will be sent to you of your campaign. You can edit your campaign at this step.")),
                        react_1.default.createElement("li", null,
                            react_1.default.createElement("p", null, "If you require approvals, this proof email will contain a link to either approve or cancel the campaign send. You can choose to send a campaign right now.")),
                        react_1.default.createElement("li", null,
                            react_1.default.createElement("p", { className: "mb-0" }, "Once your campaign is sent, it will be sent using your email service provider."))),
                    react_1.default.createElement("p", { className: "mb-0 text-right" },
                        react_1.default.createElement("a", { href: "#", onClick: e => {
                                e.preventDefault();
                                document.cookie = 'osmosys.hideWorkflowsInfoAlert=true';
                                this.setState({
                                    infoBoxIsOpen: false,
                                });
                            } }, "Don't show again")))),
                react_1.default.createElement(reactstrap_1.Row, { className: "justify-content-center mt-4" },
                    react_1.default.createElement(reactstrap_1.Col, { lg: "6", md: "10", sm: "12" },
                        react_1.default.createElement(reusables_1.Form, { mutationProps: {
                                mutation: graphql_1.updateWorkflow,
                            }, valuesToVariables: values => {
                                return {
                                    data: {
                                        campaignDefaultSubjectLine: values.campaignDefaultSubjectLine || null,
                                        campaignFromEmailAddress: values.campaignFromEmailAddress || null,
                                        campaignFromName: values.campaignFromName || null,
                                        campaignListID: values.campaignListID
                                            ? `${values.campaignListID}`
                                            : null,
                                        campaignReplyToEmailAddress: values.campaignReplyToEmailAddress
                                            ? values.campaignReplyToEmailAddress
                                            : null,
                                        campaignSubjectLineSource: values.campaignSubjectLineSource
                                            ? values.campaignSubjectLineSource.value
                                            : null,
                                        days: values.days && values.days.length > 0
                                            ? values.days.map(d => d.value)
                                            : null,
                                        emailId: values.email ? values.email.id : null,
                                        emailServiceProviderId: values.emailServiceProvider
                                            ? values.emailServiceProvider.id
                                            : null,
                                        everyday: values.everyday,
                                        minutesBeforeRunToSendProof: values.minutesBeforeRunToSendProof
                                            ? values.minutesBeforeRunToSendProof.value
                                            : null,
                                        name: values.name,
                                        requireApproval: values.requireApproval,
                                        sendProof: values.sendProof,
                                        time: values.time
                                            ? moment_1.default(values.time)
                                                .utc()
                                                .format()
                                            : null,
                                        usersThatCanApproveIds: values.usersThatCanApprove &&
                                            values.usersThatCanApprove.length
                                            ? values.usersThatCanApprove.map(u => u.id)
                                            : null,
                                        usersToSendProofsToIds: values.usersToSendProofsTo &&
                                            values.usersToSendProofsTo.length
                                            ? values.usersToSendProofsTo.map(u => u.id)
                                            : null,
                                    },
                                    id: workflow.id,
                                };
                            }, formikProps: {
                                initialValues,
                            }, showBottomToolbar: true }, formikProps => {
                            var _a, _b;
                            return (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(reactstrap_1.Row, null,
                                    react_1.default.createElement(reactstrap_1.Col, null,
                                        react_1.default.createElement(reusables_1.FormGroup, { label: "Workflow name", name: "name" }),
                                        react_1.default.createElement("br", null),
                                        react_1.default.createElement("p", { className: "lead border-bottom pb-1" },
                                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faEnvelopeOpenText, className: "mr-2" }),
                                            ' ',
                                            "Email Campaign Defaults"),
                                        react_1.default.createElement(reusables_1.FormGroup, { label: "Subject line source", type: "select", selectProps: {
                                                isClearable: true,
                                            }, options: SUBJECT_LINE_SOURCE, name: "campaignSubjectLineSource" }),
                                        react_1.default.createElement(reactstrap_1.Collapse, { isOpen: formikProps.values
                                                .campaignSubjectLineSource &&
                                                formikProps.values.campaignSubjectLineSource
                                                    .value === 'contentSystem' },
                                            react_1.default.createElement(reactstrap_1.Button, { type: "button", onClick: () => undefined, color: "primary", className: "mb-3", disabled: true }, "Select content feed (coming soon!)")),
                                        react_1.default.createElement(reactstrap_1.Collapse, { isOpen: formikProps.values
                                                .campaignSubjectLineSource &&
                                                formikProps.values.campaignSubjectLineSource
                                                    .value === 'defaultText' },
                                            react_1.default.createElement(reusables_1.FormGroup, { label: "Default subject line", name: "campaignDefaultSubjectLine" })),
                                        react_1.default.createElement(reusables_1.FormGroup, { label: "From name", name: "campaignFromName" }),
                                        react_1.default.createElement(reusables_1.FormGroup, { label: "From email address", name: "campaignFromEmailAddress" }),
                                        react_1.default.createElement(reactstrap_1.Collapse, { isOpen: !this.state.showReplyToAddressUI },
                                            react_1.default.createElement("a", { href: "#", onClick: () => this.setState({
                                                    showReplyToAddressUI: true,
                                                }) },
                                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlus, className: "mr-2" }),
                                                ' ',
                                                "Specify a different reply-to address")),
                                        react_1.default.createElement(reactstrap_1.Collapse, { isOpen: this.state.showReplyToAddressUI },
                                            react_1.default.createElement(reusables_1.FormGroup, { label: "Reply-to email address", name: "campaignReplyToEmailAddress" }),
                                            react_1.default.createElement("a", { href: "#", onClick: () => {
                                                    this.setState({
                                                        showReplyToAddressUI: false,
                                                    });
                                                    formikProps.setFieldValue('campaignReplyToEmailAddress', '');
                                                } },
                                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faMinus, className: "mr-2" }),
                                                ' ',
                                                "Remove reply-to address")),
                                        react_1.default.createElement("br", null),
                                        react_1.default.createElement("p", { className: "lead border-bottom pb-1" },
                                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCalendar, className: "mr-2" }),
                                            ' ',
                                            "Schedule"),
                                        react_1.default.createElement(reusables_1.FormGroup, { label: "Time", name: "time", type: "time" }),
                                        react_1.default.createElement(reusables_1.FormGroup, { label: "Days", name: "days", type: "select", selectProps: {
                                                isMulti: true,
                                                noOptionsMessage: () => 'All days selected',
                                            }, options: DAYS, disabled: !!formikProps.values.everyday, inputClassName: "d-inline" }),
                                        react_1.default.createElement(reusables_1.FormGroup, { label: "Every day", name: "everyday", type: "checkbox", options: DAYS }),
                                        react_1.default.createElement("br", null),
                                        react_1.default.createElement("p", { className: "lead border-bottom pb-1" },
                                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCheckDouble, className: "mr-2" }),
                                            ' ',
                                            "Proofs"),
                                        react_1.default.createElement(reactstrap_1.Row, null,
                                            react_1.default.createElement(reactstrap_1.Col, null,
                                                react_1.default.createElement(reusables_1.FormGroup, { label: "Send proof before workflow run", name: "sendProof", type: "checkbox" })),
                                            react_1.default.createElement(reactstrap_1.Col, null,
                                                react_1.default.createElement(reusables_1.FormGroup, { label: "Require approval before sending", name: "requireApproval", type: "checkbox", disabled: !formikProps.values.sendProof }))),
                                        react_1.default.createElement(reactstrap_1.Collapse, { isOpen: !!formikProps.values.sendProof },
                                            react_1.default.createElement(reusables_1.FormGroup, { label: "Send proof", name: "minutesBeforeRunToSendProof", type: "select", selectProps: {
                                                    defaultValue: {
                                                        label: '1 hour',
                                                        value: '60',
                                                    },
                                                    noOptionsMessage: () => 'All days selected',
                                                }, inputClassName: "d-inline", options: MINUTES_BEFORE_RUN_TO_SEND_PROOF, disabled: !formikProps.values.sendProof }),
                                            react_1.default.createElement(reusables_1.FormGroup, Object.assign({ name: "usersToSendProofsTo", label: "Users to send proofs to", type: "querySelect", querySelectProps: {
                                                    getOptionLabel: opt => `${opt.fullName || opt.email}${currentUser.id === opt.id ? ' (me)' : ''}`,
                                                    isMulti: true,
                                                    noOptionsMessage: () => 'No users found',
                                                    pathToCount: 'usersCount',
                                                    pathToItems: 'users',
                                                    queryProps: {
                                                        query: graphql_1.users,
                                                        variables: {
                                                            workspaceId: (_a = currentUser.currentWorkspaceMembership) === null || _a === void 0 ? void 0 : _a.workspace.id,
                                                        },
                                                    },
                                                } }, formikProps))),
                                        react_1.default.createElement(reactstrap_1.Collapse, { isOpen: !!formikProps.values.requireApproval },
                                            react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "user", multiple: true, currentUserId: currentUser.id, workspaceId: (_b = currentUser.currentWorkspaceMembership) === null || _b === void 0 ? void 0 : _b.workspace.id }))))));
                        }),
                        react_1.default.createElement(react_components_1.Mutation, { mutation: workflow.archived ? graphql_1.unarchiveWorkflow : graphql_1.archiveWorkflow, variables: { id: workflow.id }, refetchQueries: [
                                {
                                    query: graphql_1.workflow,
                                    variables: {
                                        id: workflow.id,
                                    },
                                },
                            ] }, (mutate, archiveResult) => (react_1.default.createElement(reusables_1.AjaxButton, { color: "warning", className: "mt-5", icon: pro_solid_svg_icons_1.faArchive, type: "button", successText: workflow.archived ? 'Archived' : 'Restored', label: workflow.archived
                                ? 'Unarchive workflow'
                                : 'Archive workflow', loading: archiveResult.loading, error: archiveResult.error, success: !!archiveResult.data, onConfirmation: () => {
                                mutate();
                            } }))),
                        !workflow.archived && (react_1.default.createElement("p", { className: "text-muted" },
                            react_1.default.createElement("small", null, "You can unarchive this later"))),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.deleteWorkflow, variables: { id: workflow.id }, onCompleted: () => {
                                this.props.history.push('/workflows');
                            } }, (mutate, deleteResult) => (react_1.default.createElement(reusables_1.AjaxButton, { color: "warning", className: "mb-5 mt-2", icon: pro_solid_svg_icons_1.faTrash, type: "button", label: "Delete workflow", loading: deleteResult.loading, error: deleteResult.error, success: !!deleteResult.data, onConfirmation: () => {
                                mutate();
                            } })))))));
        }));
    }
}
exports.WorkflowSettings = WorkflowSettings;
//# sourceMappingURL=WorkflowSettings.js.map